import { getApiUrl } from 'modules/Url';

type FetchMediaProcessingStatusParameters = {
  requestUuid: string;
};

export type Data = {
  audioId: string;
  userId: number;
  type: string;
  origin: string;
  duration: number;
  caption: string;
  derivedFromAudioId: number | null;
  originalAudioId: number;
  originalUserId: number;
  locale: null;
  isDeleted: boolean;
  created: string;
  modified: string;
  createdUnixTimestamp: number;
  audioFileId: number;
  videoUploadId?: number;
  color: string;
  url: string;
  uploadType: string;
};

type ProcessingState = 'processed' | 'uploaded' | 'failed';

type Request = {
  audioId: string | null;
  created: string;
  filename: string;
  modified: string;
  region: string;
  requestUuid: string;
  state: ProcessingState;
  userId: number;
};

type FetchMediaProcessingStatusResponse = {
  requestUuid: string;
  data: Data | null;
  request: Request;
};

export async function fetchMediaProcessingStatus({
  requestUuid,
}: FetchMediaProcessingStatusParameters): Promise<FetchMediaProcessingStatusResponse> {
  try {
    const resp = await fetch(
      getApiUrl({
        path: `upload/media/${requestUuid}`,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (resp.ok) {
      return resp.json();
    }
    throw new Error('Could not fetch media processing status');
  } catch (e) {
    throw new Error(e.message);
  }
}
